module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0zm5.772 18H18v3.768c0 1.06-.938 1.92-2 1.922-1.06 0-2-.862-2-1.922V18h-3.764c-1.06 0-1.92-.938-1.922-2 .002-1.062.862-2 1.922-2H14v-3.768c0-1.06.938-1.92 2-1.922 1.062.002 2 .862 2 1.922V14h3.772c1.06 0 1.922.94 1.922 2-.002 1.062-.862 2-1.922 2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/plus-2.js
// module id = 1349
// module chunks = 14